import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../models';
import { AuthService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';

@Component({
    selector: 'sn-usc-your-achievements-panel',
    templateUrl: './usc-your-achievements-panel.component.html',
    styleUrls: ['./usc-your-achievements-panel.component.css']
})
export class UscYourAchievementsPanelComponent implements OnInit {
    @Input() scope_month: string;

    public active_user: User;
    public sales_achievements: any;
    public achievement_ratings: any = {};
    public badge_placements: any[] = [];
    public user_achievement: any;
    public testing: any;
    public is_current_month: boolean = true;
    public is_achievement_loaded: boolean = false;
    public is_action_plan_submitted: boolean = false;

    constructor(
        public uscStoreService: UscStoreService,
        public authService: AuthService,
    ) { 
        this.active_user = this.authService.getActive();
        this.uscStoreService.p2wSalesTrackerTesting.subscribe(testing => {
            this.testing = testing;
            this.reloadPlacements();
        })
    }

    ngOnInit() {
        if (this.scope_month == undefined) this.scope_month = this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.reloadPlacements();

        this.uscStoreService.p2wScopeMonth.subscribe(m => {
            if (m.length == 6 && this.scope_month != m) {
                this.scope_month = m;
                this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
                this.reloadPlacements();
            }
        })        
    }

    reloadPlacements() {
        this.is_achievement_loaded = false;
        var user = JSON.parse(JSON.stringify(this.active_user)); 
        if (this.testing && this.testing.associate_ID) user.username = this.testing.associate_ID;
        this.user_achievement = this.uscStoreService.getConsultantAchievementByUser(user);
        if (!this.is_current_month) this.user_achievement = this.uscStoreService.getPreviousUserSalesVsQuotaAchievement(user, this.scope_month);
        this.is_action_plan_submitted = (this.user_achievement && (this.user_achievement.ap_status == 2 || this.user_achievement.ap_status == -1));
        // reset badge_placements for testing purpose
        this.badge_placements = [];
        if (this.user_achievement) {
            this.is_achievement_loaded = true;
            if (this.uscStoreService.isUSCellAgent()) {
                if (this.is_action_plan_submitted) {
                    if (this.is_current_month) {
                        if (this.user_achievement.agency) this.badge_placements.push({scope_type: "agency", placements: this.uscStoreService.generateConsultantPlacementsByScope("agency", this.user_achievement.agency) });
                    }
                }
            } else {
                if (this.is_current_month) {
                    if (this.user_achievement.channel)   this.badge_placements.push({scope_type: "channel", placements: this.uscStoreService.generateConsultantPlacementsByScope("channel", this.user_achievement.channel) });
                    if (this.user_achievement.region)    this.badge_placements.push({scope_type: "region", placements: this.uscStoreService.generateConsultantPlacementsByScope("region", this.user_achievement.region) });
                    if (this.user_achievement.territory) this.badge_placements.push({scope_type: "territory", placements: this.uscStoreService.generateConsultantPlacementsByScope("territory", this.user_achievement.territory) });
                    if (this.user_achievement.area)      this.badge_placements.push({scope_type: "area", placements: this.uscStoreService.generateConsultantPlacementsByScope("area", this.user_achievement.area) });
                } else {
                    if (this.user_achievement.channel)   this.badge_placements.push({scope_type: "channel", placements: this.uscStoreService.generateConsultantPlacementsFromPreviousActionPlans("channel", this.user_achievement.channel, this.scope_month) });
                    if (this.user_achievement.region)    this.badge_placements.push({scope_type: "region", placements: this.uscStoreService.generateConsultantPlacementsFromPreviousActionPlans("region", this.user_achievement.region, this.scope_month) });
                    if (this.user_achievement.territory) this.badge_placements.push({scope_type: "territory", placements: this.uscStoreService.generateConsultantPlacementsFromPreviousActionPlans("territory", this.user_achievement.territory, this.scope_month) });
                    if (this.user_achievement.area)      this.badge_placements.push({scope_type: "area", placements: this.uscStoreService.generateConsultantPlacementsFromPreviousActionPlans("area", this.user_achievement.area, this.scope_month) });
                }
            }

            this.badge_placements.forEach(bp => {
                var user_achievement = this.user_achievement;
                var scope_achievements = [];
                bp.placements.forEach(p => { scope_achievements.push(p.achievement); })
                var values = this.uscStoreService.getUniquePropertyFromArray(scope_achievements, "total_weighted_pct");
                var values_below = values.filter(function(v) {
                    return v < user_achievement.total_weighted_pct;
                });
                bp.percentile = 1 - (values_below.length / values.length);
                bp.desc = this.getAchievementDesc(bp);
                bp.sub_desc = this.getAchievementSubDesc(bp);
                bp.isPlatinum = bp.percentile <= 0.2;
                bp.isGold = !bp.isPlatinum && bp.percentile <= 0.4;
                bp.isSilver = !bp.isPlatinum && !bp.isGold && bp.percentile <= 0.6;
                bp.isBronze = !bp.isPlatinum && !bp.isGold && !bp.isSilver && bp.percentile <= 0.8;
                bp.noBadge = !bp.isPlatinum && !bp.isGold && !bp.isSilver && !bp.isBronze;

                bp.bronze_url = this.getBadgeUrl("Bronze");
                bp.silver_url = this.getBadgeUrl("Silver");
                bp.gold_url = this.getBadgeUrl("Gold");
                bp.platinum_url = this.getBadgeUrl("Platinum");
                bp.none_url = this.getBadgeUrl("None");
            })
        }
    }

    getDesc() {
        if (this.is_achievement_loaded) {
            if (this.uscStoreService.isUSCellAgent() && !this.is_action_plan_submitted) return "Please submit this month's action plan to track your achievements which are based on your weighted scorecard results.";  
            return "Congratulations, you are on track to earning the following achievements based on your weighted scorecard results:";
        } 
        return "User achievements for the month were not found.";
    }

    getAchievementDesc(bp) {
        var postfix = "'th";
        var user_badge = bp.placements.find(p => p.achievement == this.user_achievement || p.achievement.ap_ID == this.user_achievement.ap_ID);
        if (user_badge.ranking >= 11 && user_badge.ranking <= 13) {
        } else {
            var r = user_badge.ranking.toString();
            var last_digit = parseInt(r[r.length - 1]);
            switch (last_digit) {
                case 1: postfix = "'st"; break;
                case 2: postfix = "'nd"; break;
                case 3: postfix = "'rd"; break;
            }
        }

        var desc = '_RANKING__POSTFIX_ Place For Your _SCOPE_';
        var scope = bp.scope_type[0].toUpperCase() + bp.scope_type.substr(1, bp.scope_type.length - 1);
        desc = desc.replace('_RANKING_', user_badge.ranking).replace('_POSTFIX_', postfix).replace('_SCOPE_', scope);
        if (scope == "Channel") desc = desc.replace("For Your Channel", "Nationally");
        return desc;
    }

    getAchievementSubDesc(bp) {
        var desc = "(Out of _X_ Associates)".replace('_X_', bp.placements.length);
        return desc;
    }

    isPlatinum(bp) {
        return bp.percentile <= 0.2;
    }

    isGold(bp) {
        return bp.percentile <= 0.4;
    }

    isSilver(bp) {
        return bp.percentile <= 0.6;
    }

    isBronze(bp) {
        return bp.percentile <= 0.8;
    }

    getBadgeUrl(type) {
        var month = this.uscStoreService.getThisMonthActionPlanSubject();
        var url = "assets/img/usc-store/p2w/badges/" + month.substring(0, 4) + "/";
        var file = "SalesQuota-_TYPE_-_MONTH_.png".replace("_TYPE_", type).replace("_MONTH_", month);
        return url + file;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-your-achievements-panel/usc-your-achievements-panel.component.ts